









import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { DeleteShop, QueryShopList, UpdateShopStatus } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import { ShopAuditStatusFormat } from '@/utils/tyepconvert'
import AuditShopDialog from './AuditShopDialog.vue'

@Component({
  components: {
    VQuery,
    VTable,
    AuditShopDialog,
  },
})
export default class VideoList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
    // auditStatus: 1,
    auditStatusIn: [1,4],
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [{ title: '店铺名称', param: 'name' }]
  // 全局操作
  private queryOperation: Array<TableOperation> = []
  // 数据表头 -
  // 视频比例 ()
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '店铺ID', param: 'id'},
    { title: 'logo', param: 'logo', type: 'image' },
    { title: '店铺名称', param: 'name' },
    { title: '营业执照', param: 'businessLicense',type: 'image' },
    { title: '统一社会信用代码', param: 'creditCode' },
    { title: '联系人', param: 'contactsName' },
    { title: '联系人电话', param: 'contactsPhone' },
    { title: '汇付商户号', param: 'huifuMerchantNo' },
    { title: '审核状态', param: 'auditStatus' , formatter: ShopAuditStatusFormat},
    { title: '创建时间', param: 'createTime', formatter: DateFormat },
    {
      title: '操作',
      operation: [
        {
          title: '审核',
          click: (data: any)=>{
            const p = this.$refs.AuditShopDialog as AuditShopDialog
            p.open(data)
          },
          show: function (data) {
            // return true
            return data.auditStatus == 1
          },
        },
        {
          title: '入网完成',
          click: (data: any)=>{
            const p = this.$refs.AuditShopDialog as AuditShopDialog
            p.open(data)
          },
          show: function (data) {
            // return true
            return data.auditStatus == 4
          },
        },
      ],
    },
  ]

  public async created() {
    this.loadData()
  }



  private delete(data: any) {
    MessageBox.confirm('确定要删除吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await DeleteShop({ id: data.id })
      if (ruslt) {
        Message.success('删除成功')
        this.loadData()
      }
    })
  }

  private async updateOpenStatus(data: any) {
    await UpdateShopStatus({
      id: data.id,
      status: 1,
    })
    this.loadData()
  }
  private async updateCloseStatus(data: any) {
    await UpdateShopStatus({
      id: data.id,
      status: 0,
    })
    this.loadData()
  }


  public async loadData() {
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await QueryShopList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
